import axios from "axios";
import { Plugins } from "@capacitor/core";

const { Storage } = Plugins;
const baseUrl = "https://us-central1-model-space-158da.cloudfunctions.net/";

const pushTokenApiService = {
  async set(token) {
    await Storage.set({
      key: "pushToken",
      value: token
    });

    if (!token) {
      throw new Error("No token set");
    }

    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "saveDeviceToken",
        baseURL: baseUrl,
        params: {
          push_token: token
        }
      })
        .then(data => resolve(data))
        .catch(reason => reject(new Error("Save Device Token Error: " + reason.message)));
    });
  },

  async addDeviceTokenToUser(user) {
    const { value } = await Storage.get({ key: "pushToken" });
    const token = value;

    if (!token) {
      throw new Error("No device token set in local storage.");
    }

    return new Promise((resolve, reject) => {
      axios({
        method: "post",
        url: "saveDeviceToUser",
        baseURL: baseUrl,
        params: {
          push_token: `${token}`,
          user_id: user
        }
      })
        .then(data => resolve(data))
        .catch(reason => reject(new Error("Could not add device token to user in firestore. " + reason.message)));
    });
  }
};

export default pushTokenApiService;
